<template>
  <div class="container min-height flex-column justify-content-spaceBetween align-items-center">
    <div class="width-100 flex-column justify-content-start align-items-center">
      <top :active="6"></top>
      <div class="container-box width-100">
        <!--        排序方式+搜索框-->
        <div class="width-100 flex-row justify-content-spaceBetween align-items-center mb-30">
          <div class="width-50 sorting-method-box flex-row justify-content-start align-items-center">
            <p
              class="width-15 pointer fs-big"
              :class="sortingIndex === index ? 'theme-blue' : 'black'"
              v-for="(item, index) in sortingMethod"
              :key="index"
              @click="handleSortChange(index)"
            >
              {{ item }}
            </p>
          </div>
          <div class="width-40 flex-row justify-content-end align-items-center search-box border bg-white">
            <div class="width-25">
              <el-select v-model="searchType" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
            <div class="divider-v"></div>
            <el-input class="width-60" v-model="keyword" placeholder="输入关键字搜索" @keyup.enter.native="handleSearch"></el-input>
            <el-button class="width-15" size="medium" round type="primary" @click="handleSearch">搜索</el-button>
          </div>
        </div>
        <!--        鼓词作品列表-->
        <div class="width-100 flex-row justify-content-start align-items-star flex-wrap mb-30">
          <div class="guCi-item" v-for="(item, index) in guCiList" :key="index" @click="openQRCode(item)">
            <el-image :src="item.drumBalladBanner" class="guCi-picture margin-bs" fit="cover" />
            <div class="fs-mid width-100 cut-text">{{ item.drumBalladTitle }}</div>
            <div class="fs-sml darkgrey width-100 cut-text line-height2">
              {{ item.famousPerson && item.famousPerson.fpName ? item.famousPerson.fpName : '' }}
            </div>
          </div>
        </div>
        <!--        弹窗-->
        <el-dialog :visible.sync="dialogVisible" width="80%">
          <div class="dialog-box">
            <div class="dialog-image textAlign-c">
              <vue-qr :text="QRCodePicture" :size="200" :margin="10" />
            </div>
            <div class="dialog-text textAlign-c fs-big fw-bold theme-blue" style="color: #3e98ff">使用"天瑞地安"扫码<br />即可观看</div>
          </div>
        </el-dialog>
        <div class="width-100 textAlign-c">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import { getGuCiList } from '@/api/guciApi';
import vueQr from 'vue-qr';
import bottom from '../components/footer';
import top from '../components/top';
export default {
  name: 'onlineLearning',
  components: {
    top,
    bottom,
    vueQr
  },
  data() {
    return {
      sortingIndex: 0,
      sortingMethod: ['综合', '最新'],
      keyword: '',
      options: [
        {
          value: 'all',
          label: '全部'
        }
      ],
      searchType: 'all',
      guCiList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      QRCodePicture: ''
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.keyword) {
        params.drumBalladTitle = this.keyword;
      }
      getGuCiList(params).then((res) => {
        if (res.code === 200) {
          this.guCiList = res.rows || [];
          this.total = res.total || 0;
        }
      });
    },
    handleSortChange(index) {
      this.sortingIndex = index;
      this.pageNum = 1;
      this.getList();
    },
    handleSearch() {
      this.pageNum = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    openQRCode(item) {
      this.dialogVisible = true;
      this.QRCodePicture = `https://rarmtguci.wzgo.cn/guciv/#/login?goto=drummingDetails&id=${item.id}`;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background: #f3f9ff;
  .container-box {
    margin: 40px 0 80px;
    .search-box {
      border-radius: 50px;
      padding: 4px 6px 4px 8px;
    }
    .guCi-item {
      width: 31%;
      margin: 15px 1% 20px;
      background: white;
      border-radius: 10px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      padding: 15px;
    }
    .guCi-picture {
      width: 100%;
      height: 220px;
      border-radius: 10px;
    }
    .dialog-box {
      background: url('../assets/image/pic1.png') no-repeat;
      background-size: 100% 100%;
      padding: 50px 50px 30px;
      border-radius: 10px;
      overflow: hidden;
    }
    .dialog-image {
      border-radius: 10px;
      overflow: hidden;
    }
    .dialog-text {
      margin-top: 30px;
    }
  }
}
.mb-30 {
  margin-bottom: 30px;
}
/deep/.el-dialog {
  background: rgba(0, 0, 0, 0) !important;
  width: 22% !important;
  margin-top: 20vh !important;
}
</style>
